import { __assign } from "tslib";
// DS: C37D
import React from 'react';
import PremiumFolderPaywallFullView from './PremiumFolderPaywall';
import WatchersOnlyPaywallFullView from './WatchersOnlyPaywall';
import PrivilegedFolderPaywall from './PrivilegedFolderPaywall';
import { PremiumFolderType } from '../../../../types/gallection';
var Paywall = function (props) {
    var _a;
    switch ((_a = props.deviation.premiumFolderData) === null || _a === void 0 ? void 0 : _a.type) {
        case PremiumFolderType.Paid:
            return React.createElement(PremiumFolderPaywallFullView, __assign({}, props));
        case PremiumFolderType.Watchers:
            return React.createElement(WatchersOnlyPaywallFullView, __assign({}, props));
        case PremiumFolderType.Privileged:
            return React.createElement(PrivilegedFolderPaywall, __assign({}, props));
        default:
            return null;
    }
};
Paywall.displayName = 'Paywall';
export default Paywall;
//# sourceMappingURL=Paywall.js.map